import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import scanConfigurationService from "services/scanConfigurationService";

export const fetchScanConfiguration = createAsyncThunk(
  "scanConfiguration/fetchScanConfiguration",
  async (domainId, { rejectWithValue }) => {
    try {
      const resp = await scanConfigurationService.getScanConfiguration(domainId);
      return resp;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const upsertScanConfiguration = createAsyncThunk(
  "scanConfiguration/upsertScanConfiguration",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const resp = await scanConfigurationService.upsertScanConfiguration(id, data);
      return resp;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const initialState = {
  data: null,
  loading: false,
  saving: false,
  successMessage: null,
  errorMessage: null,
};

const scanConfigurationSlice = createSlice({
  name: "scanConfiguration",
  initialState,
  reducers: {
    resetScanConfigurationMessages: (state) => {
      state.successMessage = null;
      state.errorMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchScanConfiguration.pending, (state) => {
        state.loading = true;
        state.errorMessage = null;
        state.successMessage = null;
      })
      .addCase(fetchScanConfiguration.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload?.data ?? null;
      })
      .addCase(fetchScanConfiguration.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage =
          action.payload?.response?.data?.error || "error.somethingWentWrong";
      })

      .addCase(upsertScanConfiguration.pending, (state) => {
        state.saving = true;
        state.errorMessage = null;
        state.successMessage = null;
      })
      .addCase(upsertScanConfiguration.fulfilled, (state, action) => {
        state.saving = false;
        const ok =
          action.payload?.status === 200 ||
          action.payload?.status === 204 ||
          !!action.payload?.data;

        state.successMessage = ok
          ? "scanConfig.update.success"
          : null;
        state.errorMessage = ok ? null : "error.somethingWentWrong";
        state.data = action.payload?.data ?? state.data;
      })
      .addCase(upsertScanConfiguration.rejected, (state, action) => {
        state.saving = false;
        state.errorMessage =
          action.payload?.response?.data?.error || "error.somethingWentWrong";
      });
  },
});

export const { resetScanConfigurationMessages } =
  scanConfigurationSlice.actions;
export default scanConfigurationSlice.reducer;
